import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/components/auth/AuthProvider';
import { UserProvider } from '@/contexts/UserContext';
import { FDSCanvas } from '@/components/entity-modules/FDSCanvas';
import { AL3VLedger } from '@/components/entity-modules/AL3VLedger';
import { MVCCloset } from '@/components/entity-modules/MVCCloset';
import LoginPage from '@/pages/login';
import AuthCallback from '@/pages/auth-callback';

function App() {
  console.log('App.tsx loaded - timestamp: 2025-10-22T14:00:00 - OAuth enabled');
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes - Login & OAuth Callback */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* Protected Routes - Require Authentication */}
        <Route
          path="/*"
          element={
            <AuthProvider>
              <UserProvider>
                <Routes>
                  <Route path="/fdaia" element={<FDSCanvas />} />
                  <Route path="/al3viewer" element={<AL3VLedger />} />
                  <Route path="/mvc" element={<MVCCloset />} />
                  <Route path="/" element={<Navigate to="/fdaia" replace />} />
                </Routes>
              </UserProvider>
            </AuthProvider>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;